
import { Vue, Component } from 'vue-property-decorator';
import InvoiceUpload from './invoiceUpload.vue';
import InvoiceService from '@/services/invoice.service';
import lazyInject from '@/di';

@Component({
  components: {
    InvoiceUpload,
  },
})
export default class AgainInvoice extends Vue {
  @lazyInject(InvoiceService)
  protected invoiceService!: InvoiceService;

  onChange(val: any) {
    // console.log(val);
    this.license = val;
  }
  record: any;
  license: any;
  visible = false;
  title = '上传新的资格证明';
  cancel() {
    this.visible = false;
  }
  async onSubmit() {
    if (!this.license) {
      this.$message.error('请上传新的资格证明');
      return;
    }
    const _data = {
      id: this.record.id,
      license: this.license.id,
    };
    const res = await this.invoiceService.invoiceReapply(_data);
    if (res) {
      this.$message.success('提交成功');
      this.visible = false;
      this.$emit('refresh');
    }
  }
  init(record: any) {
    this.visible = true;
    this.record = record;
  }
}
